module.exports = __webpack_public_path__ + "static/media/squared-background.d8bfbfba.svg";